<div class="error-message">
  @if (hasTitle) {
    <p
      class="error-message-title"
      translate="error-renderer-message-title"
      [translateParams]="translationParams">
    </p>
  }
  <div>
    @switch (errorRenderer) {
      @case ('parameter-error') {
        <missing-parameters-error-renderer
          [mappings]="mappings"
          [errors]="errors.requiredParameters">
        </missing-parameters-error-renderer>
      }
      @case ('tool-unavailable-error') {
        <tool-unavailable-error
          >
        </tool-unavailable-error>
      }
      @case ('activity-not-found-error') {
        <activity-not-found-error-renderer
          [errors]="errors">
        </activity-not-found-error-renderer>
      }
      @case ('invalid-activity-type-change-error') {
        <invalid-activity-type-change-error-renderer
          >
        </invalid-activity-type-change-error-renderer>
      }
      @case ('course-license-expired-error') {
        <course-license-expired-error-renderer
          >
        </course-license-expired-error-renderer>
      }
      @case ('missing-deployment-error') {
        <missing-deployment-error-renderer
          [errors]="errors">
        </missing-deployment-error-renderer>
      }
      @case ('deprecated-launch-error') {
        <deprecated-launch-error-renderer
          [errors]="errors">
        </deprecated-launch-error-renderer>
      }
      @default {
        <default-error-renderer
          [errors]="errors"
          [mappings]="mappings"
          [lmsName]="lmsName">
        </default-error-renderer>
      }
    }
  </div>
</div>
